// extracted by mini-css-extract-plugin
module.exports = {"loader":"GenericLoader_loader__1Kk5q","loadingIcon":"GenericLoader_loadingIcon__1C_Fg"};